import React from "react";
import {
  WSButton,
  WSCard,
  WSElement,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import styles from "./RedirectConfirmation.module.scss";

interface RedirectConfirmationProps {
  redirectUri: string;
  onContinue: () => void;
  onCancel: () => void;
}

/** Origin of the destination, or the raw value if it will not parse. */
const destinationOrigin = (redirectUri: string): string => {
  try {
    return new URL(redirectUri).origin;
  } catch {
    return redirectUri;
  }
};

/**
 * Interstitial shown when the authorization result sets
 * `requiresDestinationConfirmation`.
 *
 * The provider raises that flag for destinations it has not verified, so the
 * person gets to see where they are being sent before the browser leaves
 * Wingspan. Only the origin is shown — the full URI carries the authorization
 * code, and putting a live credential on screen invites shoulder-surfing and
 * screenshots.
 */
export const RedirectConfirmation: React.FC<RedirectConfirmationProps> = ({
  redirectUri,
  onContinue,
  onCancel
}) => (
  <WSCard className={styles.card}>
    <WSText.Heading3 mb="M">Leaving Wingspan</WSText.Heading3>

    <WSText.Paragraph mb="XS" color="gray600">
      You're about to be sent to:
    </WSText.Paragraph>
    <WSElement mb="L">
      <WSText.Paragraph className={styles.destination}>
        {destinationOrigin(redirectUri)}
      </WSText.Paragraph>
    </WSElement>

    <WSFlexBox gap="M">
      <WSButton.Secondary onClick={onCancel} fullWidth>
        Cancel
      </WSButton.Secondary>
      <WSButton.Primary onClick={onContinue} fullWidth>
        Continue
      </WSButton.Primary>
    </WSFlexBox>
  </WSCard>
);
